import * as _ from 'lodash';
import { Action } from "redux";

import { ActionTypes } from "../actions/actionTypes";
import { Questions } from '../interfaces/questions';

export interface FillInBlankQuestionsReducerState {
  hasreceiveddata: boolean;
  data?: Questions
  error?: string;
  states: { [key: string]: string };
  newConceptModalOpen: Boolean
}

type FillInBlankQuestionsReducerAction = Action & { data: Questions, qid: string, rid: string }

export default (
  currentState = {hasreceiveddata: false, states: {}, newConceptModalOpen: false},
  action: FillInBlankQuestionsReducerAction,
) => {
  switch (action.type) {
    case ActionTypes.RECEIVE_FILL_IN_BLANK_QUESTIONS_DATA:
      return Object.assign({}, currentState, { data: action.data}, {hasreceiveddata: true})
    case ActionTypes.NO_FILL_IN_BLANK_QUESTIONS_FOUND:
      return Object.assign({}, currentState, { error: 'No fill in blank questions found.'})
    default:
      return currentState;
  }
};
